import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessOfficeCentral } from "../utils/accessControl";

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GridIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <rect x="4" y="4" width="6" height="6" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="14" y="4" width="6" height="6" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="4" y="14" width="6" height="6" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="14" y="14" width="6" height="6" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M12 4v10m0 0l-4-4m4 4 4-4M5 19h14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M6 5.5A2.5 2.5 0 0 1 8.5 3H19v16H8.5A2.5 2.5 0 0 0 6 21V5.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M6 5.5A2.5 2.5 0 0 0 3.5 8V19H19"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function NotebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 4.5H17C18.1 4.5 19 5.4 19 6.5V19.5H7C5.9 19.5 5 18.6 5 17.5V6.5C5 5.4 5.9 4.5 7 4.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.5V19.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M11 8H16"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M11 11H15"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CompassIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="7.5"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M14.7 9.3L13.1 13.1L9.3 14.7L10.9 10.9L14.7 9.3Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BookOpenIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M4.5 6.5C4.5 5.7 5.2 5.1 6 5.2C8.2 5.4 10.1 6.1 12 7.4V19C10.1 17.7 8.2 17 6 16.8C5.2 16.7 4.5 17.3 4.5 18.1V6.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 6.5C19.5 5.7 18.8 5.1 18 5.2C15.8 5.4 13.9 6.1 12 7.4V19C13.9 17.7 15.8 17 18 16.8C18.8 16.7 19.5 17.3 19.5 18.1V6.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Dashboard() {
  const navigate = useNavigate();
  const { user, refreshSession } = useAuth();
  const hasOfficeAccess = canAccessOfficeCentral(user);

  useEffect(() => {
    refreshSession();
  }, []);

   const ecosystemModules = [
     {
       id: "bitacora",
       title: "Bitácora ZEDRO",
       subtitle: "Reúne tus oraciones, reflexiones, evidencias y aprendizajes para volver a ellos cuando necesites recordar cómo has avanzado.",
       note: "Tu recorrido personal",
       icon: <NotebookIcon />,
       route: "/bitacora",
     },
     {
       id: "conexion",
       title: "Conexión ZEDRO",
       subtitle: "Encuentra orientación en la Palabra, enfoca tu oración y expresa con claridad lo que estás viviendo.",
       note: "Oración guiada",
       icon: <SparkIcon />,
       route: "/conexion",
     },
    ];

  return (
    <main
      style={{
        minHeight: "100vh",
        background: "var(--page-bg)",
      }}
    >
      <div className="z-dashboard-shell">
        <section className="z-dashboard-hero">
          <div className="z-dashboard-kicker">
            ZEDRO Academy
          </div>

          <h1 className="z-dashboard-title">
            {user?.name ? `Hola, ${user.name}` : "Hola"}
          </h1>

          <p className="z-dashboard-subtitle">
            ¡Aquí es donde comienzas a expandir tus raíces!
          </p>
        </section>

        {hasOfficeAccess && (
          <section className="z-dashboard-section" style={{ marginBottom: "2rem" }}>
            <h2 className="z-dashboard-sectionTitle">Oficina Central</h2>

            <div
              className="z-premium-card z-premium-card--module"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/admin")}
            >
              <div className="z-card-top">
                <span className="z-card-label">Administración</span>
                <div className="z-card-icon">
                  <SparkIcon />
                </div>
              </div>

              <div>
                <h3 className="z-card-title z-card-title--sm">Gestión Empresarial</h3>
                <p className="z-card-copy">
                  Producción, productos, miembros, suscripciones y operación interna.
                </p>
              </div>

              <div className="z-card-actions">
                <span className="z-card-link">
                  Entrar
                  <ArrowIcon />
                </span>
              </div>
            </div>
          </section>
        )}

        <section className="z-dashboard-section">
          
          <div
            className="z-premium-card z-premium-card--core"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/core")}
          >
            <div className="z-card-top">
              <h3 className="z-card-title" style={{ margin: 0 }}>
                Cimientos ZEDRO
              </h3>

              <div className="z-card-icon">
                <GridIcon />
              </div>
            </div>

            <p className="z-card-copy">
              Sistemas guiados para llevar la Palabra a la vida cotidiana y construir una vida 
              más consciente, coherente y arraigada en Dios.
            </p>

            <div className="z-card-actions">
              <div className="z-card-meta">
                <span className="z-card-dot" />
                <span>El punto de partida para ordenar la vida desde la raíz.</span>
              </div>

              <span className="z-card-link">
                Entrar a Cimientos
                <ArrowIcon />
              </span>
            </div>
          </div>
        </section>

        <section className="z-dashboard-section">
          <h2 className="z-dashboard-sectionTitle">Explora ZEDRO</h2>

          <div className="z-dashboard-grid z-dashboard-grid--ecosystem">
            {ecosystemModules.map((mod) => (
              <button
                key={mod.id}
                type="button"
                className="z-premium-card z-premium-card--module z-dashboard-moduleBtn"
                onClick={() => navigate(mod.route)}
              >
                <div className="z-card-top">
                  <h3 className="z-card-title z-card-title--sm" style={{ margin: 0 }}>
                    {mod.title}
                  </h3>

                  <div className="z-card-icon z-card-icon--soft">
                    {mod.icon}
                  </div>
                </div>

                <p className="z-card-copy z-card-copy--compact">
                  {mod.subtitle}
                </p>

                <div className="z-card-footer">
                  <span className="z-card-meta z-card-meta--clean">
                    {mod.note}
                  </span>

                  <span className="z-card-link z-card-link--minimal">
                    Abrir
                    <ArrowIcon />
                  </span>
                </div>
              </button>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}